// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ref, get } from "firebase/database";
// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import { auth, firestore, database as realtimeDB } from "../FirebaseConfig"; // Import Firebase DBs
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Navigation, Autoplay } from "swiper/modules";
// import toast from "react-hot-toast";

// export default function BestSellingProduct() {
//   const [bestSellingProducts, setBestSellingProducts] = useState([]);

//   const handleAddToCart = async (product,id) => {
//     if (!auth.currentUser) {
//       toast.error("Please log in to add items to your cart.");
//       // alert("Please log in to add items to your cart.");
//       // navigate(`/login?redirect=/`);
//       return;
//     }

//     if (  product.stock<1) {

//       return
//     }
//       ;

//     // setAddingToCart(true);
//     const userId = auth.currentUser.uid;
//     const cartRef = doc(firestore, "customers", userId);
//     toast.loading("Adding Item .!");

//     try {
//       const cartSnap = await getDoc(cartRef);

//       if (cartSnap.exists()) {
//         const cartData = cartSnap.data();
//         let updatedCart = { ...cartData };

//         if (updatedCart.items) {
//           const existingItemIndex = updatedCart.items.findIndex(item => item.productId === id);

//           if (existingItemIndex !== -1) {
//             updatedCart.items[existingItemIndex].quantity += 1;
//           } else {
//             updatedCart.items.push({ productId: id, quantity:1 });
//           }
//         } else {
//           updatedCart = { items: [{ productId: id, quantity:1 }] };
//         }

//         await updateDoc(cartRef, updatedCart);
//       } else {
//         await setDoc(cartRef, { items: [{ productId: id, quantity:1 }] });
//       }
//       toast.dismiss();
//       toast.success("Item added to cart!");
//     } catch (error) {
//       toast.dismiss();

//       console.error("Error adding to cart:", error);
//       toast.error("Error adding item to cart. Please try again.");
//     }

//     // setAddingToCart(false);
//   };



//   useEffect(() => {
//     const fetchBestSellingData = async () => {
//       const bestSellRef = ref(realtimeDB, "bestSell");
//       const snapshot = await get(bestSellRef);

//       if (snapshot.exists()) {
//         const data = snapshot.val();
       
//         // Fetch product details from Firestore using product IDs
//         const productPromises = data.products.map(async (productId) => {
//           const productRef = doc(firestore, "products", productId);
//           const productSnap = await getDoc(productRef);

//           return productSnap.exists() ? { id: productId, ...productSnap.data() } : null;
//         });

//         const fetchedProducts = (await Promise.all(productPromises)).filter(Boolean);
//         setBestSellingProducts(fetchedProducts);
//       }
//     };

//     fetchBestSellingData();
//   }, []);


// //   .wt-separator {
// //     display: block;
// //     height: 2px;
// //     margin-bottom: 5px !important;
// //     margin: auto;
// //     position: relative;
// //     transition: width 0.3s ease;
// //     width: 40px;
// //   }
// //   .wt-separator2 {
// //     display: block;
// //     height: 2px;
// //     margin: auto;
// //     position: relative;
// //     transition: width 0.3s ease;
// //     width: 60px;
// //   }

  

// return (
//   <div className="m-5">
//     <div className="text-center mb-6">
//       <h3 className="text-2xl font-bold">You may also like</h3>
//       <div className="w-16 h-1 bg-orange-500 mx-auto mt-2"></div>
//     </div>

//       {/* Left Side Banner */}
 
//       {/* Right Side Swiper for Best Selling Products */}
//       <div className="col-span-2">
//         {bestSellingProducts.length === 0 ? (
//           // Shimmer Effect for Loading Products
//           <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//             {[1, 2, 3].map((index) => (
//               <div key={index} className="border rounded-md p-4 bg-white shadow-md animate-pulse">
//                 <div className="h-40 bg-gray-200 rounded-md"></div>
//                 <div className="mt-3">
//                   <div className="h-4 bg-gray-300 w-3/4 rounded-md"></div>
//                   <div className="mt-2 h-4 bg-gray-300 w-1/2 rounded-md"></div>
//                 </div>
//                 <div className="mt-4 h-8 bg-gray-400 w-full rounded-md"></div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <Swiper
//             modules={[Navigation, Autoplay]}
//             spaceBetween={10}
//             slidesPerView={1}
//             breakpoints={{
//               1024: { slidesPerView: 3 }, // For large screens
//               492: { slidesPerView: 2 }, // For medium screens
//             }}
//             autoplay={{ delay: 2500 }}
//             className="rounded-md"
//           >
//             {bestSellingProducts.map((product) => {
//               const actualPrice = product.prices.productPrice;
//               const offerPrice = actualPrice - product.prices.productDiscount;
//               const discountPercent = (
//                 (product.prices.productDiscount / actualPrice) *
//                 100
//               ).toFixed(0);

//               return (
//                 <SwiperSlide key={product.id}>
//                   <div className="border rounded-md p-2 bg-white shadow-md">
//                     <Link to={`/product/${product.id}`} className="block text-center">
//                       <img
//                         src={product.thumbnail}
//                         alt={product.name}
//                         className="md:h-45 h-50 object-contain mx-auto"
//                       />
//                     </Link>
//                     <div className="mt-3 text-center">
//                       <h4 className="text-md font-semibold">{product.name}</h4>
//                       <div className="flex justify-center items-center mt-1 space-x-2">
//                         {product.prices.productDiscount > 0 ? (
//                           <>
//                             <span className="text-lg font-bold text-green-600">₹{offerPrice}</span>
//                             <span className="text-sm line-through text-gray-500">₹{actualPrice}</span>
//                             <span className="text-sm bg-red-500 text-white px-2 py-1 rounded-md">
//                               {discountPercent}% OFF
//                             </span>
//                           </>
//                         ) : (
//                           <span className="text-lg font-bold text-gray-800">₹{actualPrice}</span>
//                         )}
//                       </div>
//                       <button
//                         onClick={() => handleAddToCart( product,product.id)}
//                         className="mt-3 bg-orange-500 font-bold text-white px-4 py-2 rounded-md w-40"
//                       >
//                         Add to Cart
//                       </button>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               );
//             })}
//           </Swiper>
//         )}
//       </div>
//   </div>
// );

// }


import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ref, get } from "firebase/database";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, firestore, database as realtimeDB } from "../FirebaseConfig";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import {
  ShoppingCart,
  Star,
  ArrowLeft,
  ArrowRight,
  Sparkles,
} from "lucide-react";

export default function BestSellingProduct() {
  const [bestSellingProducts, setBestSellingProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  const handleAddToCart = async (product, id) => {
    if (!auth.currentUser) {
      toast.error("Please log in to add items to your cart.");
      return;
    }

    if (!product || (product.stock ?? 0) < 1) {
      toast.error("This product is currently out of stock.");
      return;
    }

    const userId = auth.currentUser.uid;
    const cartRef = doc(firestore, "customers", userId);
    const toastId = toast.loading("Adding to cart...");

    try {
      const cartSnap = await getDoc(cartRef);
      let updatedCart = { items: [] };

      if (cartSnap.exists()) {
        const cartData = cartSnap.data() || {};
        updatedCart = { ...cartData };
        if (!Array.isArray(updatedCart.items)) {
          updatedCart.items = [];
        }
      }

      const existingItemIndex = updatedCart.items.findIndex(
        (item) => item.productId === id
      );

      if (existingItemIndex !== -1) {
        updatedCart.items[existingItemIndex].quantity += 1;
      } else {
        updatedCart.items.push({ productId: id, quantity: 1 });
      }

      if (cartSnap.exists()) {
        await updateDoc(cartRef, updatedCart);
      } else {
        await setDoc(cartRef, updatedCart);
      }

      toast.dismiss(toastId);
      toast.success("Added to cart!");
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.dismiss(toastId);
      toast.error("Error adding item to cart. Please try again.");
    }
  };

  useEffect(() => {
    const fetchBestSellingData = async () => {
      try {
        const bestSellRef = ref(realtimeDB, "bestSell");
        const snapshot = await get(bestSellRef);

        if (snapshot.exists()) {
          const data = snapshot.val();

          if (!data?.products || !Array.isArray(data.products)) {
            setBestSellingProducts([]);
            setLoading(false);
            return;
          }

          const productPromises = data.products.map(async (productId) => {
            const productRef = doc(firestore, "products", productId);
            const productSnap = await getDoc(productRef);
            return productSnap.exists()
              ? { id: productId, ...productSnap.data() }
              : null;
          });

          const fetched = (await Promise.all(productPromises)).filter(Boolean);
          setBestSellingProducts(fetched);
        } else {
          setBestSellingProducts([]);
        }
      } catch (err) {
        console.error("Error fetching best selling products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBestSellingData();
  }, []);

  const scrollBy = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.firstChild?.getBoundingClientRect()?.width || 260;
    el.scrollBy({
      left: direction * (cardWidth + 24),
      behavior: "smooth",
    });
  };

  const renderSkeleton = () => (
    <div
      ref={scrollRef}
      className="flex gap-4 overflow-x-auto hide-scrollbar py-2"
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="min-w-[220px] max-w-[220px] rounded-2xl border border-amber-50 bg-white shadow-sm p-3 animate-pulse"
        >
          <div className="h-32 rounded-xl bg-gray-200 mb-3" />
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-4" />
          <div className="h-9 bg-gray-300 rounded-lg" />
        </div>
      ))}
    </div>
  );

  // --------- UI ---------
  return (
    <section className="mt-10 mb-10">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.4 }}
          className="flex items-center justify-between gap-3 mb-4"
        >
          <div>
            <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-amber-500 mb-1">
              <Sparkles className="h-3 w-3" />
              <span>Recommended For You</span>
            </div>
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-900">
              Customers also loved
            </h3>
          </div>

          {/* Arrow controls (hidden on small screens) */}
          <div className="hidden sm:flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollBy(-1)}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-amber-100 bg-white text-slate-600 shadow-sm hover:bg-amber-50 hover:text-amber-700 transition"
              aria-label="Scroll left"
            >
              <ArrowLeft className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => scrollBy(1)}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-amber-100 bg-white text-slate-600 shadow-sm hover:bg-amber-50 hover:text-amber-700 transition"
              aria-label="Scroll right"
            >
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </motion.div>

        {/* Slider row */}
        {loading ? (
          renderSkeleton()
        ) : bestSellingProducts.length === 0 ? (
          <div className="text-center text-sm text-gray-500 py-6">
            No recommended products available right now.
          </div>
        ) : (
          <div className="relative">
            {/* mobile arrows floating */}
            <div className="pointer-events-none absolute inset-y-0 left-0 right-0 flex justify-between items-center sm:hidden">
              <button
                type="button"
                onClick={() => scrollBy(-1)}
                className="pointer-events-auto ml-1 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/90 shadow-md text-slate-600"
              >
                <ArrowLeft className="h-4 w-4" />
              </button>
              <button
                type="button"
                onClick={() => scrollBy(1)}
                className="pointer-events-auto mr-1 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/90 shadow-md text-slate-600"
              >
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>

            <motion.div
              ref={scrollRef}
              className="flex gap-4 overflow-x-auto py-2 hide-scrollbar scrollbar-thin scrollbar-thumb-amber-300/70 scrollbar-track-transparent"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.3 }}
            >
              {bestSellingProducts.map((product, idx) => {
                const price = product?.prices?.productPrice || 0;
                const discount = product?.prices?.productDiscount || 0;
                const hasDiscount = discount > 0 && price > 0;
                const offerPrice = hasDiscount ? price - discount : price;
                const discountPercent = hasDiscount
                  ? Math.round((discount / price) * 100)
                  : 0;

                const stockNum = Number(product.stock || 0);
                const inStock = stockNum > 0;
                const lowStock = inStock && stockNum <= 10;

                const rating = product.rating || 4.5; // optional
                const ratingCount = product.ratingCount || 120; // optional

                return (
                  <motion.div
                    key={product.id}
                    className="min-w-[220px] max-w-[220px] sm:min-w-[240px] sm:max-w-[240px]"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.25, delay: idx * 0.04 }}
                    whileHover={{ y: -6 }}
                  >
                    <div className="group relative flex h-full flex-col rounded-2xl border border-amber-100/70 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)] overflow-hidden">
                      {/* Discount badge */}
                      {hasDiscount && (
                        <div className="absolute left-3 top-3 z-10 rounded-full bg-red-500/90 px-2.5 py-1 text-[11px] font-semibold text-white shadow-sm">
                          {discountPercent}% OFF
                        </div>
                      )}

                      {/* Stock pill */}
                      <div className="absolute right-3 top-3 z-10">
                        {inStock ? (
                          <span
                            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium border ${
                              lowStock
                                ? "bg-amber-50 text-amber-700 border-amber-200"
                                : "bg-emerald-50 text-emerald-700 border-emerald-200"
                            }`}
                          >
                            <span
                              className={`mr-1 h-1.5 w-1.5 rounded-full ${
                                lowStock ? "bg-amber-500" : "bg-emerald-500"
                              }`}
                            />
                            {lowStock ? `${stockNum} left` : "In stock"}
                          </span>
                        ) : (
                          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium bg-red-50 text-red-600 border border-red-200">
                            Out of stock
                          </span>
                        )}
                      </div>

                      {/* Image area */}
                      <Link
                        to={`/product/${product.id}`}
                        className="block bg-gradient-to-b from-amber-50/90 via-white to-amber-50/60"
                      >
                        <div className="flex items-center justify-center px-3 pt-7 pb-4">
                          <div className="relative w-full">
                            <div className="mx-auto flex h-32 sm:h-36 items-center justify-center rounded-xl bg-white/85 border border-amber-100 shadow-inner overflow-hidden">
                              <motion.img
                                src={
                                  product.thumbnail ||
                                  product.images?.[0] ||
                                  "/assets/General/placeholder.png"
                                }
                                alt={product.name}
                                className="h-full w-auto max-h-32 sm:max-h-36 object-contain"
                                loading="lazy"
                                onError={(e) => {
                                  e.currentTarget.src =
                                    "/assets/General/placeholder.png";
                                }}
                                whileHover={{ scale: 1.05 }}
                                transition={{ type: "spring", stiffness: 260 }}
                              />
                            </div>
                            <div className="pointer-events-none absolute inset-x-6 bottom-0 h-1 bg-gradient-to-r from-amber-200/0 via-amber-300/80 to-amber-200/0 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                          </div>
                        </div>
                      </Link>

                      {/* Content */}
                      <div className="flex flex-1 flex-col px-3 pb-3 pt-1 sm:px-4 sm:pb-4">
                        <Link
                          to={`/product/${product.id}`}
                          className="line-clamp-2 text-[13px] sm:text-sm font-semibold text-slate-900 hover:text-orange-600 transition-colors"
                        >
                          {product.name}
                        </Link>

                        {/* Rating row (optional visual richness) */}
                        <div className="mt-1 flex items-center gap-1.5 text-[11px] text-slate-500">
                          <Star className="h-3.5 w-3.5 text-amber-400 fill-amber-400" />
                          <span className="font-semibold text-slate-800">
                            {rating.toFixed(1)}
                          </span>
                          <span>({ratingCount})</span>
                        </div>

                        {/* Price */}
                        <div className="mt-2 flex items-center gap-2">
                          <span className="text-base sm:text-lg font-bold text-emerald-700">
                            ₹{offerPrice}
                          </span>
                          {hasDiscount && (
                            <>
                              <span className="text-xs line-through text-gray-400">
                                ₹{price}
                              </span>
                              <span className="rounded-full bg-red-50 px-2 py-0.5 text-[10px] font-semibold text-red-600 border border-red-100">
                                Save ₹{discount}
                              </span>
                            </>
                          )}
                        </div>

                        {/* Button */}
                        <button
                          onClick={() =>
                            inStock && handleAddToCart(product, product.id)
                          }
                          disabled={!inStock}
                          className={[
                            "mt-3 w-full rounded-full py-2 text-xs sm:text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-1.5",
                            inStock
                              ? "bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow hover:shadow-lg hover:brightness-105 active:scale-[0.97]"
                              : "bg-gray-200 text-gray-500 cursor-not-allowed",
                          ].join(" ")}
                        >
                          <ShoppingCart className="h-4 w-4" />
                          {inStock ? "Add to Cart" : "Out of stock"}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
}
